import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquare } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 px-4" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-19">
            Sé Honesto Contigo Mismo...
          </h2>
          <p className="text-xl text-slate-400" data-id="element-20">
            Marca mentalmente si algo de esto te resuena:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-slate-900 border border-slate-800 rounded-3xl p-8 shadow-lg" data-id="element-21">
          <ul className="space-y-6 mb-8" data-id="element-22">
            {["Tienes más de 35 años y has notado que 'ya no es como antes'", 'Has gastado dinero en pastillas o suplementos que solo funcionaron la primera vez', 'Sientes un nudo en el estómago antes de un encuentro íntimo', 'Te da vergüenza hablar de esto incluso con tu médico', 'Buscas una solución que puedas hacer en privado, sin que nadie se entere', 'Estás cansado de sentir que tu cuerpo te traiciona cuando más lo necesitas'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-23">
                <CheckSquare className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" data-id="element-24" />
                <span className="text-lg text-slate-300" data-id="element-25">{text}</span>
              </li>)}
          </ul>

          <div className="p-6 bg-slate-950 rounded-2xl border border-slate-800 text-center" data-id="element-26">
            <p className="text-xl font-bold text-white mb-3" data-id="element-27">
              Si marcaste al menos 2... esto es exactamente lo que necesitas.
            </p>
            <p className="text-slate-400 mb-2" data-id="element-28">
              No porque seas "viejo". No porque hayas "perdido el toque".
            </p>
            <p className="text-blue-400 font-semibold text-lg" data-id="element-29">
              Porque tu cuerpo solo necesita el estímulo correcto para responder
              como siempre lo hizo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}